import usePosOrderUser from "@/shared/atoms/usePosOrderUser";
import Textfield from "../Input/Textfield";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useCountryConfigHook from "@/shared/hooks/useCountryConfigHook";

const HouseNumberExtension = () => {
  const { t } = useTranslation();
  const { register } = useFormContext();
  const [orderUser] = usePosOrderUser();
  const { isTurkiye } = useCountryConfigHook();

  return (
    <Textfield
      ref={register({})}
      defaultValue={orderUser?.house_number_extension}
      label={
        isTurkiye
          ? t("posOrders.apartmentNumber")
          : t("posOrders.houseNumberExtension")
      }
      name="order_user.house_number_extension"
    />
  );
};

export default HouseNumberExtension;
